/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiMeetingFeaturesAttendeeCapabilitiesFromJSON(json) {
    return StreemApiMeetingFeaturesAttendeeCapabilitiesFromJSONTyped(json, false);
}
export function StreemApiMeetingFeaturesAttendeeCapabilitiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audio': !exists(json, 'audio') ? undefined : json['audio'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'video': !exists(json, 'video') ? undefined : json['video'],
    };
}
export function StreemApiMeetingFeaturesAttendeeCapabilitiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audio': value.audio,
        'content': value.content,
        'video': value.video,
    };
}
//# sourceMappingURL=StreemApiMeetingFeaturesAttendeeCapabilities.js.map